import QuoteOfWeek from './QuoteOfWeek';

export default QuoteOfWeek;
